import type { ThemeName, Theme } from './types';

export const DEFAULT_THEME: ThemeName = 'dusk';

export const THEMES: Record<ThemeName, Theme> = {
  dusk: {
    label: 'dusk',
    bgBase: '#16171e',
    bgSurface: '#191b24',
    bgElevated: '#1e1f28',
    bgHover: '#2a2833',
    textPrimary: '#ebebeb',
    textMuted: '#a898b3',
    textDim: '#7a7085',
    accent: '#cc76a9',
    borderAccent: '#754967',
    egoAccent: '#76cc99',
    egoBorder: '#497566',
    borderSubtle: 'rgba(235, 235, 235, 0.12)',
    blue: '#3d46c2',
  },
  light: {
    label: 'light',
    bgBase: '#f0eff2',
    bgSurface: '#f8f7fa',
    bgElevated: '#ffffff',
    bgHover: '#e8e6ec',
    textPrimary: '#1a1a2e',
    textMuted: '#6b5b7b',
    textDim: '#7d6c8f',
    accent: '#5c46c2',
    borderAccent: '#403864',
    egoAccent: '#acc246',
    egoBorder: '#5c6438',
    borderSubtle: 'rgba(0, 0, 0, 0.10)',
    blue: '#3d46c2',
  },
  dawn: {
    label: 'dawn',
    bgBase: '#1e1a16',
    bgSurface: '#24201a',
    bgElevated: '#2a261e',
    bgHover: '#38322a',
    textPrimary: '#ebebde',
    textMuted: '#b3a898',
    textDim: '#857a6a',
    accent: '#cc9a76',
    borderAccent: '#755c49',
    egoAccent: '#76a9cc',
    egoBorder: '#496275',
    borderSubtle: 'rgba(235, 230, 220, 0.12)',
    blue: '#3d46c2',
  },
};
